<template>
  <div class="mobile-none-more">
    手机端最多显示本场直播打赏最多的5位达人
  </div>
</template>

<script>
  export default {
    
  }
</script>

<style lang="less" scoped>
  .mobile-none-more {
    text-align: center;
    line-height: 1.2rem;
    color: #A1AEBF;
    font-size: .24rem;
  }
</style>